<template>
  <div class="h100">
    <router-view v-if="ready" />
  </div>
</template>

<script>
import tokenRefreshService from "@/services/tokenRefreshService";

export default {
  mixins: [
    require("@mix/timer").default,
    require("@mix/notifyToken").default
  ],
  computed: {
    ...mapState(["isLogin"]),
  },
  data() {
    return {
      ready: false
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 開啟 App 時靠這邊, 背景回到前景 靠 @mix/webview 的 onActive
    async init() {
      try {
        await this.$store.dispatch("GetRefreshToken");
        this.event_notifyToken();
        this.ready = true;
        this.$store.commit("SET_IS_DOCUMENT_READY", true);

        // 當 App 開啟時，檢查並排程下次刷新 Token 時間
        if (this.isLogin) {
          tokenRefreshService.initTokenRefresh();
        }
      } catch (error) {
        // NOTIFICATION("e", error?.message || "系統錯誤");
        this.ready = true;
        this.$store.commit("SET_IS_DOCUMENT_READY", true);
      }
    }
  }
}
</script>

<style>
</style>